import React from "react";
import { Flex, Heading } from "theme-ui";
import { Testimonial } from "../molecules";
import { typography } from '../../styles/theme';

const TestimonialSection = ({
  nodes,
  heading,
  backgroundColor,
  customStyles,
}) => {
  return (
    <Flex
      id="feature-clients"
      sx={{
        ...styles.container,
        backgroundColor: backgroundColor,
        ...customStyles,
      }}
    >
      <Heading
        as="h2"
        sx={{
          ...typography.h2,
          textAlign: "center",
        }}
      >
        {heading}
      </Heading>
      <Flex sx={styles.wrapper}>
        {nodes?.map((t, i) => ( 
          <Testimonial
            variant="secondary"
            subVariant="secondaryOne"
            employeeDesignation={t?.employeeDesignation}
            employeeName={t?.employeeName}
            feedback={t?.feedback}
            rating={t?.rating}
            image={t?.testimonialImage?.gatsbyImageData}
            imageAltText={`${t?.employeeName}-${t?.testimonialImage?.alt}`}
            companyName={t?.companyName}
            companyLogo={t?.companyLogo?.gatsbyImageData}
            companyLogoAltText={t?.companyLogoAltText}
            reviewUrl={t?.slug}
            key={`testimonial-${i}`}
            innerContainerCustomStyles={{
              minHeight: ["15.625rem", "15.625rem", "17.5rem", "25.813rem"]
            }}
          />
        ))}
      </Flex>
    </Flex>
  );
};

const styles = {
  container: {
    mt: [5, 5, "7rem", "7rem"],
    py: [5, 5, "7rem"],
    px: [3, 3, 4, "6.25rem"],
    alignItems: "center",
    flexDirection: "column",
  },
  wrapper: {
    gap: ["4.625rem", "4.625rem", "4.625rem", "1.5rem"],
    mt: "6.125rem",
    flexDirection: "row",
    "@media(max-width: 1200px)": {
      flexDirection: "column",
      gap: "4.625rem",
    },
  },
};

export default TestimonialSection;
